import React, { useState, useEffect, useRef } from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import PageSearch from '../search/PageSearch';
import ListView from '../list/ListView';
import Api from '../../services/ApiService';
import history from '../../history';

const columnDefs = [
  {
    pinned: 'left',
    headerName: '',
    field: 'action',
    suppressSizeToFit: true,
    suppressMenu: true,
    sortable: false,
    cellStyle: { textAlign: true },
    width: 90,
    cellRenderer: cellProps => {
      return (
        <div className="text-center">
          <ButtonGroup className="list-row-toolbar">
            <Button
              onClick={event => {
                const url = `/db/UST3R/${cellProps.data.id}/edit`;
                if (event.ctrlKey) {
                  window.open(url);
                } else {
                  history.push(url);
                }
              }}
              variant="info"
              size="xs"
              title="Edit Permissions"
            >
              <i className="fas fa-lock-open" />
            </Button>
          </ButtonGroup>
        </div>
      );
    },
  },
  { headerName: 'Username', field: 'username' },
  { headerName: 'Email', field: 'email' },
  { headerName: 'First Name', field: 'firstName' },
  { headerName: 'Last Name', field: 'lastName' },
  { headerName: 'Branch Name', field: 'branchName' },
];

const PagePermissions = () => {
  const [rowData, setRowData] = useState([]);
  const [permMap, setPermMap] = useState({});
  const [pageName, setPageName] = useState('');

  const listView = useRef(null);

  useEffect(() => {
    Api.get('/user/page/permissionmap').then(response => {
      setPermMap(response.data);
    });
  }, []);

  const onChange = p => setPageName(p);

  const handleChange = (data, suggestion) => {
    if (!data || !suggestion || !suggestion.name) {
      return;
    }

    setRowData(permMap[suggestion.name] || []);
  };

  const handleExport = () => {
    const fileName = `PagePermissions-${pageName.replace(/\s+/g, '-')}.csv`;

    listView.current.agGrid.api.exportDataAsCsv({ fileName });
  };

  return (
    <>
      <div style={{ margin: '0 15px 15px 15px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ flexGrow: 1, marginRight: '10px' }}>
            <PageSearch
              placeholder="Search Page"
              onSuggestionSelected={handleChange}
              onChange={onChange}
              showAuthOnly={false}
              value={pageName}
            />
          </div>
          <div>
            <Button onClick={handleExport} disabled={!pageName} variant="secondary">
              Export
            </Button>
          </div>
        </div>
        <h6>Users in list have permission to selected page</h6>
      </div>

      <ListView ref={listView} columnDefs={columnDefs} rowData={rowData} showToolbar={false} showRowToolbar={false} />
    </>
  );
};

export default PagePermissions;
